import { iRecord } from 'features/trade/components/OrderTable/types';

const vtOrderList = (data: any[]): iRecord[] =>
  data.map((item: any) => ({
    action: item.action,
    amount_fee: item.amount.fee,
    amount_invested: item.amount.invested,
    amount_matched: item.amount.matched,
    currency: item.currency,
    gtc: item.gtc.enable ? 1 : 0,
    gtc_expired: item.gtc.expired,
    gtc_status: item.gtc.status,
    order_done: item.done,
    order_open: item.open,
    order_total: item.total,
    orderid: item.id,
    market_orderid: item.market_order_id,
    price: item.price,
    price_average: item.price_average,
    status: item.status,
    symbol: item.symbol,
    time: item.time.created,
    time_open: item.time.open,
    time_match: item.time.match,
    total: item.total,
    platform_order_type: item.platform_order_type,
    smart_order_bracket_order_child: [],
    smart_order_parent_id: '',
    smart_order_parent_price: 0,
    message: item?.message,
  }));

const vtPortfolioList = (data: any) => ({
  ...data,
  // transform to the legacy schema
  tradingbalance: data.trading_balance,
  amount_invested: data.amount.invested,
  amount_allocated: data.amount.allocated,
  amount_creditlimit: data.amount.credit_limit,
  unrealised_profitloss: data.profit_loss.unrealized,
  realised_profitloss: data.profit_loss.realized,
  profitloss: data.profit_loss.total,
  equity: data.equity,
  gain: data.gain,
  // transform to the legacy schema
  result: data.result.map((item: any) => ({
    available_lot: item.available_lot,
    balance_lot: item.balance_lot,
    symbol: item.symbol,
    sell_open: item.sell_open.total,
    sell_open_today: item.sell_open.today,
    total: item.total,
    price: item.price.order,
    price_average: item.price.average,
    price_latest: item.price.market,
    unrealised_marketvalue: item.unrealized.market_value,
    unrealised_profitloss: item.unrealized.profit_loss,
    unrealised_gain: item.unrealized.gain,
    name: item.name,
  })),
});

export default {
  vtOrderList,
  vtPortfolioList,
};
